import { Injectable } from '@angular/core';

// Import services:
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioAnalisisService {

  constructor( private requestUrl : ReportesRequestService ) {}

  public async getResponseReporteAnalisis( objetoAnalisis : AnalisisServiceEntity ) {

    try {

      let response = await this.requestUrl.getRequest(
        "cif/analisis-habilidad",
        [ objetoAnalisis.codigoBaseDatos, { "uncoAfiliado" : objetoAnalisis.id } ]
      );

      if( response != null ) {
        return response;
      } else {
        return null;
      }

    } catch ( exception ) {
      console.log( "Servico Análisis Exception:\n" + exception );
    }

  }

  public async getResponseAfiliado( objetoAnalisis : AnalisisServiceEntity ) {

    try {

      let response = await this.requestUrl.getRequest(
        "afiliados/datos-afiliados",
        [ objetoAnalisis.codigoBaseDatos, { "ln_unco_afldo" : objetoAnalisis.id } ]
      );

      if( response != null ) {
        return response;
      } else {
        return null;
      }

    } catch ( exception ) {
      console.log( "Servico Análisis Exception:\n" + exception );
    }

  }

}

export interface AnalisisServiceEntity {
  codigoBaseDatos : string,
  id : string
}

export interface AnalisisEntity {
  identificacion : string,
  nombreCompletoAfiliado : string,
  fechaNacimiento : Date
  celular : string,
  telefono : string
}